import { editorColors as colors } from "../../styles/theme";
import { COLORS_PALETTE } from "./constants";

export default function ColorPicker({ onSelect, onClose }) {
  return (
    <div
      style={{
        position: "absolute",
        top: "100%",
        left: 0,
        marginTop: 4,
        background: colors.bgCard,
        border: `1px solid ${colors.border}`,
        borderRadius: 8,
        padding: 10,
        boxShadow: "0 12px 40px rgba(0,0,0,0.5)",
        zIndex: 200,
      }}
    >
      <div
        style={{
          fontSize: 10,
          color: colors.textSecondary,
          textTransform: "uppercase",
          letterSpacing: "0.06em",
          fontWeight: 700,
          marginBottom: 8,
        }}
      >
        Text Color
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 4,
        }}
      >
        {COLORS_PALETTE.map((color) => (
          <button
            key={color}
            onClick={() => {
              onSelect(color);
              onClose();
            }}
            style={{
              width: 28,
              height: 28,
              borderRadius: 4,
              border: `2px solid ${color === "#000925" ? colors.borderLight : "transparent"}`,
              background: color,
              cursor: "pointer",
              transition: "transform 0.1s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.transform = "scale(1.15)")
            }
            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
          />
        ))}
      </div>
    </div>
  );
}
